import { useMemo } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs, hotEvents, siteInfo } from "@/mocks/guagua";
import Hero from "./components/Hero";
import HotEventsSection from "./components/HotEventsSection";
import CategorySection from "./components/CategorySection";
import WeeklySection from "./components/WeeklySection";
import MustSeeSection from "./components/MustSeeSection";
import FaqSection from "./components/FaqSection";

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        alternateName: "网爆吃瓜合集导航",
        url: "https://yoovx.cn/",
        description:
          "网爆吃瓜合集导航页，汇集网爆吃瓜热门事件、一周盘点与必看清单，按热度整理，快速找到精选列表和汇总帖。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        url: "https://yoovx.cn/",
        email: siteInfo.email,
        description: siteInfo.intro,
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "网爆吃瓜热门事件",
        itemListElement: hotEvents.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.title,
          url: `https://yoovx.cn/collection/${item.id}`,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ],
    []
  );

  usePageMeta({
    title: "网爆吃瓜合集导航 - 热门事件·一周盘点·必看清单汇总帖",
    description:
      "网爆吃瓜合集导航页，汇集网爆吃瓜热门事件、一周盘点与必看清单，精选列表和汇总帖按热度整理，快速找到网爆吃瓜精选列表，一站式吃完全部瓜。",
    keywords: "网爆吃瓜,网爆吃瓜合集导航,网爆吃瓜热门事件,网爆吃瓜一周盘点,网爆吃瓜必看清单,网爆吃瓜汇总帖",
    path: "/",
    jsonLd,
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <HotEventsSection />
        <CategorySection />
        <WeeklySection />
        <MustSeeSection />
        <FaqSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}